"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadingStylesMap = exports.fontWeights = exports.variants = void 0;
exports.variants = {
    "header-32": {
        fontSize: "2rem",
        lineHeight: 0.875,
    },
    "header-24": {
        fontSize: "1.5rem",
        lineHeight: 1.16,
    },
    "subHeader-20": {
        fontSize: "1.25rem",
        lineHeight: 1.4,
    },
    "subHeader-16": {
        fontSize: "1rem",
        lineHeight: 1.5,
    },
    "body-14": {
        fontSize: "0.875rem",
        lineHeight: 1.6,
    },
    "body-12": {
        fontSize: "0.75rem",
        lineHeight: 1.3,
    },
};
exports.fontWeights = {
    heavy: {
        fontWeight: 800,
    },
    "semi-bold": {
        fontWeight: 600,
    },
    regular: {
        fontWeight: 400,
    },
};
exports.loadingStylesMap = {
    small: { width: 120 },
    default: { width: 150 },
    large: { width: 250 },
    full: { width: "100%" },
};
